import { Observer } from '@poa/state';
import cx from 'classnames';
import React from 'react';
import { ProfileTabForm } from './tabs/profile-tab-form';
import { ProfileTabHistory } from './tabs/profile-tab-history';
import { ProfileTabIncome } from './tabs/profile-tab-income';
import ProfileTabRequisites from './tabs/profile-tab-requisites';
import { ProfileTabPasswordHistory } from './tabs/profile-tab-password';

function getTabStyle(currentTab, tab) {
  return cx('tab-control tab-control_rounded', {
    active: currentTab === tab
  });
}

const questionnaireTab = 'questionnaire';
const historyTab = 'history';
const incomeTab = 'income';
const commentsTab = 'comments';
const requisitesTab = 'requisites';
const passwordTab = 'passwords';
const tabs = [questionnaireTab, historyTab, incomeTab, commentsTab, requisitesTab, passwordTab];

const tabsNamesMap = {
  [questionnaireTab]: 'анкета',
  [historyTab]: 'история',
  [incomeTab]: 'доход',
  [commentsTab]: 'комментарии',
  [requisitesTab]: 'реквизиты для выплаты',
  [passwordTab]: 'пароли'
};

function getCurrentTabView(props) {
  switch (props.state.currentTab) {
    case questionnaireTab:
      return (
        <ProfileTabForm
          state={props.state}
          selectedSite={props.selectedSite}
          variant={props.variant}
          requestGallery={props.requestGallery}
        />
      );
    case historyTab:
      return <ProfileTabHistory state={props.state} />;
    case incomeTab:
      return <ProfileTabIncome state={props.state} />;
    case requisitesTab:
      return <ProfileTabRequisites state={props.state} />;
    case passwordTab:
        return <ProfileTabPasswordHistory state={props.state} />;
    default:
      console.warn(`Can't map ${props.state.currentTab} to any view ${tabs}`);
      return (
        <div className="tab active" data-tab="questionnaire">
          <div className="tab__inner">Under construction</div>
        </div>
      );
  }
}

function getCurrentContent(props) {
  const isPhotoContent = props.state.galleryMode === 'photo';
  const isVideoContent = props.state.galleryMode === 'video';
  const isTabsContent = !isPhotoContent && !isVideoContent;

  switch (props.variant) {
    case 'credentials':
    case 'agency':
    case 'staff':
      return (
        <div className="tabs js-subpopup-hide">
          <div className="tabs__controls">
            {tabs.slice(0, 1).map(tab => (
              <Observer key={tab}>
                {() => (
                  <button
                    className={getTabStyle(props.state.currentTab, tab)}
                    onClick={() => props.requestTabChange(tab)}
                    data-tab={tab}
                  >
                    {tabsNamesMap[tab]}
                  </button>
                )}
              </Observer>
            ))}
            {tabs.slice(4, 6).map(tab => (
              <Observer key={tab}>
                {() => (
                  <button
                    className={getTabStyle(props.state.currentTab, tab)}
                    onClick={() => props.requestTabChange(tab)}
                    data-tab={tab}
                  >
                    {tabsNamesMap[tab]}
                  </button>
                )}
              </Observer>
            ))}
          </div>
          <Observer>{() => getCurrentTabView(props)}</Observer>
        </div>
      );

    default:
      break;
  }

  const data = props.state.model.account[props.selectedSite.get().value];

  if (isTabsContent) {
    return (
      <div className="tabs js-subpopup-hide">
        <div className="tabs__controls">
          {tabs.map((tab, index) => {
            if (tab === 'comments') {
              return null;
            }
            return (
              <Observer key={tab}>
                {() => (
                  <button
                    className={getTabStyle(props.state.currentTab, tab)}
                    onClick={() => props.requestTabChange(tab)}
                    data-tab={tab}
                  >
                    {tabsNamesMap[tab]}
                  </button>
                )}
              </Observer>
            );
          })}
        </div>
        <Observer>{() => getCurrentTabView(props)}</Observer>
      </div>
    );
  }

  if (isPhotoContent) {
    return (
      <div className="sub-popup" style={{ display: 'block' }}>
        <div className="account-photo">
          <ul className="account-photo__list">
            {(data.photos || []).map(photo => {
              return (
                <li className="account-photo__item" key={photo}>
                  <img src={photo} alt="profile" className="account-photo__img" />
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }

  if (isVideoContent) {
    return (
      <div className="sub-popup" data-subpopup="video" style={{ display: 'block' }}>
        <VideoGalleryPreview videoUrls={data.videos} />
      </div>
    );
  }
}

class VideoGalleryPreview extends React.Component {
  state = { selected: 0 };

  render() {
    const { videoUrls } = this.props;

    const urls = videoUrls.map(url => url.replace('watch?v=', 'embed/'));

    return (
      <div className="account-video">
        <div className="account-video__preview active">
          <div className="account-video__video">
            <iframe
              title="youtube"
              width="560"
              height="315"
              src={urls[this.state.selected]}
              frameBorder="0"
              allowFullScreen={true}
            />
          </div>
        </div>
        <div className="account-video__list">
          {urls.map((url, idx) => {
            return (
              <div className="account-video__preview" key={url} style={{ cursor: 'pointer' }}>
                <div
                  className="account-video__video"
                  onClick={event => {
                    event.preventDefault();
                    this.setState({ selected: idx });
                  }}
                >
                  <iframe
                    style={{ pointerEvents: 'none' }}
                    title={`youtube-${idx}`}
                    width="560"
                    height="315"
                    src={url}
                    frameBorder="0"
                    allowFullScreen={true}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export function ProfileModalContent(props) {
  return (
    <div className="popup__top">
      <Observer>{() => getCurrentContent(props)}</Observer>
    </div>
  );
}
